import { render, staticRenderFns } from "./AppGroup.vue?vue&type=template&id=c0d18cea&scoped=true"
import script from "./AppGroup.vue?vue&type=script&lang=ts"
export * from "./AppGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d18cea",
  null
  
)

export default component.exports